import { Typography, Select, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import styles from "./LeaveHeaderWithMonthYear.module.css";
import moment from "moment";
import { useEffect, useState } from "react";

const { Option } = Select;

const LeaveHeaderWithMonthYear = ({ onDateChange }) => {
  const [currentDate, setCurrentDate] = useState(moment());

  const handlePrevMonth = () => {
    const updated = moment(currentDate).subtract(1, "month");
    setCurrentDate(updated);
    triggerDateChange(updated);
  };

  const handleNextMonth = () => {
    const updated = moment(currentDate).add(1, "month");
    setCurrentDate(updated);
    triggerDateChange(updated);
  };

  const handleYearChange = (year) => {
    const updated = moment(currentDate).year(year);
    setCurrentDate(updated);
    triggerDateChange(updated);
  };

  const triggerDateChange = (date) => {
    if (onDateChange) {
      const selectedMonth = date.format("MM");
      const selectedYear = date.format("YYYY");
      onDateChange({ month: selectedMonth, year: selectedYear });
    }
  };

  const currentYear = currentDate.year();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);

  useEffect(() => {
    triggerDateChange(currentDate);
  }, []);

  return (
    <div className={styles.main_view}>
      <Typography className={styles.title}>List of Leave Requests</Typography>

      <div className={styles.top_view}>
        <div style={{ display: "flex" }}>
          <Button
            type="text"
            icon={<LeftOutlined />}
            onClick={handlePrevMonth}
          />
          <Typography
            className={styles.month_title}
            style={{
              minWidth: 70,
              textAlign: "center",
              alignContent: "center",
            }}
          >
            {currentDate.format("MMMM")}
          </Typography>
          <Button
            type="text"
            icon={<RightOutlined />}
            onClick={handleNextMonth}
          />
        </div>

        <Select
          value={currentDate.year()}
          onChange={handleYearChange}
          style={{ width: 100 }}
        >
          {years.map((year) => (
            <Option key={year} value={year}>
              {year}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default LeaveHeaderWithMonthYear;
